import "./Home.css";
import { useScrollAnimation } from "../hooks/useScrollAnimation";
import { useNavigate } from "react-router-dom";
import { ASSETS_URL } from "../util/constants";

function Home() {
  useScrollAnimation();
  const navigate = useNavigate();

  const handleJoinCompetitionClick = () => {
    navigate("/register");
  };

  const handleViewLeaderboardClick = () => {
    navigate("/leaderboard");
  };

  return (
    <div className="homepage">
      {/* hero*/}
      <section
        className="hero-section"
        style={{
          backgroundImage: "url(/assets/background/leaders_decalc.png)",
        }}
      >
        <div className="hero-content">
          <div className="hero-text">
            <h1 className="hero-title">
              <div className="hero-title-top">Welcome to</div>
              <div className="hero-title-bottom">
                <span className="highlight">PokeLeaders</span>
              </div>
            </h1>
            <p className="hero-subtitle">
              The ultimate Pokémon GO ranking platform where trainers compete,
              collect medals, and showcase their achievements in the most
              comprehensive leaderboard system.
            </p>
            <div className="hero-buttons">
              <button
                className="btn-primary"
                onClick={handleJoinCompetitionClick}
              >
                Join the Competition
              </button>
              <button
                className="btn-secondary"
                onClick={handleViewLeaderboardClick}
              >
                View Leaderboard
              </button>
            </div>
          </div>
          <div className="hero-image">
            <div className="leaderboard-preview">
              <div className="preview-header">
                <h3>Global Leaderboard</h3>
                <span className="update-time">Updated 2 min ago</span>
              </div>
              <div className="preview-entries">
                <div className="preview-entry rank-1 team-instinct">
                  <div className="team-decal instinct"></div>
                  <span className="rank">#1</span>
                  <img
                    src={`${ASSETS_URL}/avatar/player-go.png`}
                    alt="Player"
                    className="avatar"
                  />
                  <div className="player-info">
                    <span className="player-name">Hoppuz</span>
                    <div className="player-details">
                      <span className="player-level">Level 50</span>
                      <img
                        src="assets/country/br.png"
                        alt="Brazil"
                        className="country-flag"
                      />
                    </div>
                  </div>
                  <div className="player-stats">
                    <span className="xp">466,321,099 XP</span>
                    <span className="medals">79 Medals</span>
                  </div>
                </div>
                <div className="preview-entry rank-2 team-mystic">
                  <div className="team-decal mystic"></div>
                  <span className="rank">#2</span>
                  <img
                    src={`${ASSETS_URL}/avatar/victor.png`}
                    alt="Player"
                    className="avatar"
                  />
                  <div className="player-info">
                    <span className="player-name">brunohadji</span>
                    <div className="player-details">
                      <span className="player-level">Level 50</span>
                      <img
                        src="assets/country/br.png"
                        alt="Brazil"
                        className="country-flag"
                      />
                    </div>
                  </div>
                  <div className="player-stats">
                    <span className="xp">387,654,321 XP</span>
                    <span className="medals">72 Medals</span>
                  </div>
                </div>
                <div className="preview-entry rank-3 team-valor">
                  <div className="team-decal valor"></div>
                  <span className="rank">#3</span>
                  <img
                    src={`${ASSETS_URL}/avatar/backpacker.png`}
                    alt="Player"
                    className="avatar"
                  />
                  <div className="player-info">
                    <span className="player-name">R3it0r</span>
                    <div className="player-details">
                      <span className="player-level">Level 50</span>
                      <img
                        src="assets/country/br.png"
                        alt="Brazil"
                        className="country-flag"
                      />
                    </div>
                  </div>
                  <div className="player-stats">
                    <span className="xp">176,543,210 XP</span>
                    <span className="medals">64 Medals</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Sobre*/}
      <section className="about-section">
        <div className="container">
          <div className="about-content">
            <h2 className="section-title">About PokeLeaders</h2>
            <p className="about-text">
              PokeLeaders is the premier platform for Pokémon GO trainers to
              track their progress, compete with others, and showcase their
              achievements. Our comprehensive ranking system takes into account
              your XP, medal collection, and various in-game accomplishments to
              create the most accurate leaderboard possible.
            </p>
            <div className="features-grid">
              <div className="feature-card">
                <div className="feature-icon">
                  <img src="assets/icons/ranking.png" alt="Global Rankings" />
                </div>
                <h3>Global Rankings</h3>
                <p>
                  Compete with trainers worldwide and see how you stack up
                  against the best.
                </p>
              </div>
              <div className="feature-card">
                <div className="feature-icon">
                  <img src="assets/icons/medal.png" alt="Medal Collection" />
                </div>
                <h3>Medal Collection</h3>
                <p>
                  Track and display your complete medal collection with detailed
                  progress tracking.
                </p>
              </div>
              <div className="feature-card">
                <div className="feature-icon">
                  <img
                    src="assets/icons/analytics.webp"
                    alt="Detailed Analytics"
                  />
                </div>
                <h3>Detailed Analytics</h3>
                <p>
                  Get insights into your gameplay with comprehensive statistics
                  and trends.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/*Medalhas */}
      <section className="medals-section">
        <div className="container">
          <h2 className="section-title">Featured Medals</h2>
          <p className="section-subtitle">
            Showcase your Pokémon GO medals and earn exclusive new ones
          </p>
          <div className="medals-grid">
            <div className="medal-card">
              <img
                src={`${ASSETS_URL}/badge/medals/AceTrainer_Gold.png`}
                alt="Ace Trainer Medal"
                className="medal-image"
              />
              <div className="medal-info">
                <h3>Ace Trainer</h3>
                <p>Train 1000 times</p>
                <div className="medal-progress">
                  <div className="progress-bar">
                    <div
                      className="progress-fill"
                      style={{ width: "75%" }}
                    ></div>
                  </div>
                  <span className="progress-text">1750/2000</span>
                </div>
              </div>
            </div>
            <div className="medal-card">
              <img
                src={`${ASSETS_URL}/badge/collectionables/Rookidee.png`}
                alt="Rookidee Community Day Medal"
                className="medal-image"
              />
              <div className="medal-info">
                <h3>Community Day - Rookidee</h3>
                <p>Earned by attending a Community Day event</p>
                <div className="medal-progress">
                  <div className="progress-bar">
                    <div
                      className="progress-fill"
                      style={{ width: "100%" }}
                    ></div>
                  </div>
                  <span className="progress-text">1/1</span>
                </div>
              </div>
            </div>
            <div className="medal-card">
              <img
                src={`${ASSETS_URL}/badge/medals/Collector_Platinum.png`}
                alt="Collector Medal"
                className="medal-image"
              />
              <div className="medal-info">
                <h3>Collector</h3>
                <p>Catch 50.000 Pokémon</p>
                <div className="medal-progress">
                  <div className="progress-bar">
                    <div
                      className="progress-fill"
                      style={{ width: "100%" }}
                    ></div>
                  </div>
                  <span className="progress-text">160.240/50.000</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Mini_perfil*/}
      <section className="profile-preview-section" style={{backgroundImage: "url(/assets/background/profile.png)"}}>
        <div className="container">
          <h2 className="section-title">Your Profile</h2>
          <p className="section-subtitle">
            Track your progress and showcase your achievements
          </p>
          <div className="profile-preview">
            <div className="profile-card">
              <div className="profile-header">
                <img
                  src={`${ASSETS_URL}/avatar/player-go.png`}
                  alt="Profile"
                  className="profile-avatar"
                />
                <div className="profile-info">
                  <div className="profile-name-container">
                    <h3>Hthor93</h3>
                    <img
                      src="../assets/country/br.png"
                      alt="Brazil Flag"
                      className="country-flag"
                    />
                  </div>
                  <div className="level-badge">Level 46</div>
                  <div className="team-badge">
                    <img src="assets/team/team_blue.png" alt="Team Mystic" />
                    <span>Team Mystic</span>
                  </div>
                </div>
              </div>
              <div className="profile-stats">
                <div className="stat-item">
                  <span className="stat-label">Total XP</span>
                  <span className="stat-value">96,234,567</span>
                </div>
                <div className="stat-item">
                  <span className="stat-label">Medals</span>
                  <span className="stat-value">46</span>
                </div>
                <div className="stat-item">
                  <span className="stat-label">Global Rank</span>
                  <span className="stat-value">#3,234</span>
                </div>
              </div>
              <div className="recent-achievements">
                <h4>Recent Achievements</h4>
                <div className="achievement-list">
                  <div className="achievement-item">
                    <img
                      src={`${ASSETS_URL}/badge/medals/AceTrainer_Gold.png`}
                      alt="Achievement"
                    />
                    <span>Ace Trainer - Gold</span>
                  </div>
                  <div className="achievement-item">
                    <img
                      src={`${ASSETS_URL}/badge/collectionables/Rookidee.png`}
                      alt="Achievement"
                    />
                    <span>Community Day - Rookidee</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Section Divider */}
      <div className="section-divider"></div>

      {/* Discord*/}
      <section className="discord-section" style={{backgroundImage: "url(/assets/background/discord.png)"}}>
        <div className="container">
          <div className="discord-content">
            <div className="discord-text">
              <h2 className="section-title">Join Our Community</h2>
              <p className="discord-description">
                Stay updated with the latest project developments, connect with
                elite trainers, and participate in exclusive events to compete
                for special new medals and rewards.
              </p>
              <div className="discord-stats">
                <div className="stat">
                  <span className="stat-number">24/7</span>
                  <span className="stat-label">Community Support</span>
                </div>
                <div className="stat">
                  <span className="stat-number">Weekly</span>
                  <span className="stat-label">Events & Contests</span>
                </div>
              </div>
              <a className="discord-button" href="https://discord.gg/xtqDSm7wBT" target="_blank" rel="noopener noreferrer">
                <img
                  src="assets/socials/Discord-Symbol-White.png"
                  alt="Discord"
                />
                Join Discord Server
              </a>
            </div>
            <div className="discord-image">
              <img
                src="logo.png"
                alt="PokeLeaders Logo"
                className="community-image"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Visual divider between Discord and CTA sections */}
      <hr className="section-divider-hr" />

      {/*final "call to action"*/}
      <section className="cta-section">
        <div className="container">
          <div className="cta-content">
            <h2>Ready to Start Your Journey?</h2>
            <p>
              Join thousands of trainers and start climbing the leaderboard
              today!
            </p>
            <div className="cta-buttons">
              <a className="btn-primary large" href="/register">Create Account</a>
              <button className="btn-secondary large">Support Us</button>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Home;
